import { lazy } from "react";
import { durations } from "../../config/animations";

export default lazy(() =>
  Promise.all([import("./JobPackage"), new Promise(r => setTimeout(r, durations.routeTransition + 20))]).then(m => m[0])
);
